import * as React from "react";

import { DropdownContext } from "./DropdownProvider";

export const DropdownInput = () => {
    const {
        classes, inputType, invalidInput, inputProps
    } = React.useContext(DropdownContext);

    return (
        <input
            className={classes?.input}
            type={inputType}
            aria-invalid={invalidInput ? true : null}
            {...inputProps}
        />
    );
};
